import React from "react";
import { CheckCircle2, CreditCard } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";

const PLANS = [
  { id: "starter", price: "199,000", incl: ["100 minutes/сар", "Үндсэн KB", "Имэйл дэмжлэг"] },
  { id: "growth", price: "799,000", incl: ["1,000 minutes/сар", "Олон ажилтан", "Эскалацийн дүрэм"], featured: true },
  { id: "enterprise", price: "Сонир.холб", incl: ["Хязгааргүй", "SLA 99.9%", "Хувьчилсан дуу хоолой"] },
];

export default function Billing() {
  const { t, lang } = useI18n();
  const { tenant } = useAuth();
  return (
    <div className="space-y-6" data-testid="billing-page">
      <div>
        <div className="chip"><CreditCard className="h-3 w-3" /> {t("billing.title")}</div>
        <h1 className="mt-3 text-3xl lg:text-4xl font-extrabold text-white tracking-tight">{t("billing.title")}</h1>
        <p className="mt-1 text-slate-400 text-sm">{t("billing.sub")}</p>
      </div>
      <div className="glass rounded-2xl p-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-400 font-bold">{t("billing.current")}</div>
          <div className="mt-1 text-2xl font-extrabold text-gradient capitalize" data-testid="current-plan">{tenant?.plan || "starter"}</div>
        </div>
        <div className="text-xs text-slate-500" data-testid="billing-mock-note">{t("billing.mock_note")}</div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {PLANS.map((p) => (
          <div key={p.id} className={`relative rounded-2xl p-7 ${p.featured ? "glass glow-border shadow-glow" : "glass"}`} data-testid={`billing-tier-${p.id}`}>
            {p.featured && <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-gradient-to-r from-primary to-magenta text-xs font-bold text-white">★</div>}
            <div className="text-sm font-bold uppercase tracking-widest text-magenta">{t(`landing.plan_${p.id}`)}</div>
            <div className="mt-3 text-3xl font-extrabold text-white tracking-tight">
              {p.price === "Сонир.холб" ? p.price : `₮${p.price}`}
              {p.price !== "Сонир.холб" && <span className="text-sm font-medium text-slate-400">/{lang === "mn" ? "сар" : "mo"}</span>}
            </div>
            <ul className="mt-5 space-y-2 text-sm text-slate-300">
              {p.incl.map((x) => <li key={x} className="flex items-center gap-2"><CheckCircle2 className="h-4 w-4 text-magenta" /> {x}</li>)}
            </ul>
            <button disabled={tenant?.plan === p.id} className={`mt-6 w-full ${p.featured ? "btn-primary" : "btn-ghost"} disabled:opacity-40`} data-testid={`billing-select-${p.id}`}>
              {tenant?.plan === p.id ? t("billing.current") : t("billing.upgrade")}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
